/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { clearTransactionData, fetchTransaction, selectTransactionData, setTransactionData } from '../../store/slices/api/inner/transactionSlice';
import useApiRequest from '../../store/slices/hook/useApiRequest';
import Main from '../../components/HOC/Main';
import CustomTable from '../../components/common/CustomTable';
import { formateDate } from '../../components/common/FormateDate';



export const TransactionPage = () => {
  const transactionData = useSelector(selectTransactionData);

  const { handleSubmit: fetchData } = useApiRequest({
    apiAction: fetchTransaction,
    setValueAction: setTransactionData,
    clearValueActionOnError: clearTransactionData,
    isForm: false,
    successMessage: false,
  });


  const columns = useMemo(() => [
    {
      accessorKey: 'order_id',
      cell: info => <span>{info.row.original.order_id}<br/>(Gateway : {info.row.original.payment_gateway})</span>,
      filterFn: 'includesStringSensitive',
      header: "order id"
    },
    {
      accessorKey: 'name',
      cell: info => <span>{info.row.original.user.name} {info.row.original.user.surname}<br/>{info.row.original.user.email}</span>,
      filterFn: 'includesStringSensitive',
      header: "Customer Info"
    },
    {
      accessorKey: 'amount',
      cell: info => `£ ` + info.getValue()/100,
      filterFn: 'includesStringSensitive',
      header: "amount"
    },
    {
      accessorKey: 'updatedAt',
      cell: info => formateDate(info.getValue()),
      filterFn: 'includesStringSensitive',
      header: "payment date"
    },

    {
      accessorKey: 'payment_status',
      cell: info => <span className={`${info.getValue() === 'pending' ? 'text-yellow-800 border-yellow-400 bg-yellow-100' : 'text-green-800 border-green-400 bg-green-100'} text-xs font-medium me-2 px-2.5 py-0.5 rounded border`}>{info.getValue()}</span>,
      filterFn: 'includesStringSensitive',
      header: "payment status"
    },

  ], []);

  useEffect(() => {
    fetchData(); 
  }, [])

  return (
    <Main crumbs={[{ title: "transaction" }]} >
      <CustomTable columns={columns} data={transactionData} />
    </Main>
  );
};
